import React from 'react';
import { otoCardOnFile } from '@/data/conciergeOto';

// §concierge-oto — owner-approved safeguard #1: a visible notice at the
// treatment checkout BEFORE the card is saved, shown only when the post-payment
// one-click offer's card-on-file path is active (flag on + NY treatment
// checkout). With the backend flag on, the backend stores the card on any
// checkout that sends a verificationToken, so the patient must see this first.
// Copy agreed with the backend/owner 2026-10-11.
export const OTO_CARD_SAVE_NOTICE =
  "We'll securely save this card with Square so you can add a Dr. Mavroson concierge program in one click after checkout. You won't be charged for anything you don't choose.";

const OtoCardSaveNotice = ({ answers, visitType }) => {
  if (!otoCardOnFile(answers, visitType)) return null;
  return (
    <p
      className="mb-3 text-xs leading-snug text-gray-600 bg-gray-50 border border-gray-200 rounded-lg p-3"
      data-testid="oto-card-save-notice"
    >
      {OTO_CARD_SAVE_NOTICE}
    </p>
  );
};

export default OtoCardSaveNotice;
